import { NgModule } from '@angular/core';
import { ImageModule } from '@nano/common/image';

import { LogoComponent } from './logo.component';
@NgModule({
  imports: [ImageModule],
  declarations: [LogoComponent],
  exports: [LogoComponent]
})
export class LogoModule {}
